import audio from './audio.vue'
export default {
  install:function(Vue){
    window.audioList=[]
    Vue.component("m-audio",audio);
  }
}



//////////////////
// WEBPACK FOOTER
// ./app/components/audio/audio.js
// module id = null
// module chunks = 